// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-dashboard-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.agent-dashboard-container .table-filters {
  display: flex;
  column-gap: 24px;
}
.agent-dashboard-container .table-filters > div {
  align-items: center;
  display: flex;
  column-gap: 8px;
}
.agent-dashboard-container .table-filters .suggestion {
  position: absolute;
  top: 100%;
  left: 0;
  width: 300px;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0px 5px 20px 0px #EBEBEB;
  z-index: 1000;
  background-color: white;
  border-radius: 10px;
}
.agent-dashboard-container .table-filters .suggestion .suggestion-item {
  padding: 0px 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: 0.2s ease-in-out;
}
.agent-dashboard-container .table-filters .suggestion .suggestion-item:hover {
  background-color: #f1f1f1;
}
.agent-dashboard-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
}
.agent-dashboard-container .contents p {
  margin: 0;
}
.agent-dashboard-container .contents .showings-today-container {
  height: calc(100vh - 292px);
}
.agent-dashboard-container .contents .block {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.agent-dashboard-container .contents .block .data > div {
  flex: 1 1;
}
.agent-dashboard-container .contents .view-all {
  font-size: 12px;
  font-weight: 700;
  color: #5F5F5F;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.agent-dashboard-container .contents .view-all:hover {
  opacity: 0.75;
}
.agent-dashboard-container .contents .divider.team-member {
  background: #88B7FF;
}
.agent-dashboard-container .contents .divider.listing-agent {
  background: var(--primary-color-1);
}
.agent-dashboard-container .contents .divider.buyer-agent {
  background: #9E3645;
}
.agent-dashboard-container .contents .divider.buyer-agent.listing-agent {
  background: linear-gradient(#9E3645 50%, var(--primary-color-1) 50%);
}
.agent-dashboard-container .contents .border-r {
  border-right: 1px solid #E4E4E4;
}
.agent-dashboard-container .contents .border-b {
  border-bottom: 1px solid #E4E4E4;
}
.agent-dashboard-container .contents .border-rb {
  border-bottom: 1px solid #E4E4E4;
  border-right: 1px solid #E4E4E4;
}
.agent-dashboard-container .contents .header {
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: var(--secondary-color-1);
}
.agent-dashboard-container .contents .link {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.agent-dashboard-container .contents .link:hover {
  opacity: 0.75;
}
.agent-dashboard-container .contents .subheader {
  font-size: 12px;
  color: #5F5F5F;
  font-weight: 600;
}
.agent-dashboard-container .contents .title {
  color: #949494;
  font-weight: 500;
  font-size: 12px;
}
.agent-dashboard-container .contents .data {
  font-weight: 400;
  font-size: 24px;
  color: var(--secondary-color-1);
}
.agent-dashboard-container .contents .list {
  animation: fadein 0.5s;
}
.agent-dashboard-container .contents .showings-today {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  animation: fadein 0.5s;
}
.agent-dashboard-container .contents .showings-today img {
  max-height: 170px;
  width: 100%;
  object-fit: cover;
  border-radius: 24px;
}
.agent-dashboard-container .contents .showings-today .user {
  display: flex;
  margin-top: 15px;
  height: 56px;
  background-color: var(--secondary-color-4);
  padding: 12px 16px;
  border-radius: 14px;
  width: 100%;
}
.agent-dashboard-container .contents .showings-today .user.la {
  background-color: #FEF7DE;
}
.agent-dashboard-container .contents .showings-today .user.ba {
  background-color: #FEF2F2;
}
.agent-dashboard-container .contents .showings-today .user.buyer.Q {
  background-color: #fef0de;
}
.agent-dashboard-container .contents .showings-today .user .profile {
  width: 32px;
  height: 32px;
  align-self: center;
  border-radius: 100%;
}
.agent-dashboard-container .contents .showings-today .user .detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.agent-dashboard-container .contents .showings-today .user .detail span:first-child {
  font-size: 12px;
  color: #2a2a2a;
  font-weight: 700;
  margin-bottom: 5px;
}
.agent-dashboard-container .contents .showings-today .user .detail span:first-child > svg {
  margin-left: 3px;
}
.agent-dashboard-container .contents .showings-today .user .detail span:last-child {
  font-size: 10px;
  color: #949494;
  font-weight: 700;
}
.agent-dashboard-container .contents .splide__pagination {
  display: flex;
  column-gap: 5px;
}
.agent-dashboard-container .contents .splide__pagination li button.splide__pagination__page {
  height: 4px !important;
  width: 4px !important;
  padding: 0;
  border: none;
  border-radius: 100%;
  background-color: #C9C9C9;
  transition: 0.2s ease-in-out;
}
.agent-dashboard-container .contents .splide__pagination li button.splide__pagination__page.is-active {
  background-color: #949494;
}
.agent-dashboard-container .contents .splide__arrows {
  display: flex !important;
  column-gap: 16px;
}
.agent-dashboard-container .contents .splide__arrows .splide__arrow {
  cursor: pointer;
  transition: 0.2s ease-in-out;
  height: 16px;
}
.agent-dashboard-container .contents .splide__arrows .splide__arrow:hover {
  opacity: 0.75;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .agent-dashboard-container .dashboard-filters-container {
    display: none;
  }
  .agent-dashboard-container .contents {
    margin-top: 0;
  }
  .agent-dashboard-container .contents .block .data {
    flex-wrap: nowrap;
  }
  .agent-dashboard-container .contents .block .data > div {
    flex: none;
  }
  .agent-dashboard-container .contents .block .list {
    row-gap: 30px;
  }
  .agent-dashboard-container .contents .block .list > li {
    flex-wrap: wrap-reverse;
    row-gap: 8px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .agent-dashboard-container .dashboard-filters-container {
    display: none;
  }
  .agent-dashboard-container .contents {
    margin-top: 0;
  }
  .agent-dashboard-container .contents .block .data {
    flex-wrap: nowrap;
  }
  .agent-dashboard-container .contents .block .data > div {
    flex: none;
  }
  .agent-dashboard-container .contents .block .list {
    row-gap: 30px;
  }
  .agent-dashboard-container .contents .block .list > li {
    flex-wrap: wrap-reverse;
    row-gap: 8px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .agent-dashboard-container .contents > div {
    flex-direction: column;
    align-items: center;
  }
  .agent-dashboard-container .contents .showings-today-container {
    height: 100%;
  }
  .agent-dashboard-container .contents .block {
    width: 100%;
    border-right: none !important;
  }
  .agent-dashboard-container .contents .block.no-max-mobile {
    max-width: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/Dashboard/dashboard.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAEI;EACI,aAAA;EACA,gBAAA;AAAR;AACQ;EACI,mBAAA;EACA,aAAA;EACA,eAAA;AACZ;AACQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACZ;AAAY;EACI,iBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,4BAAA;AAEhB;AADgB;EACI,yBAAA;AAGpB;AAGI;EACI,gBAAA;EACA,+BAAA;AADR;AAEQ;EACI,SAAA;AAAZ;AAEQ;EACI,2BAAA;AAAZ;AAEQ;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAAZ;AAGgB;EACI,SAAA;AADpB;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AAJZ;AAMY;EACI,aAAA;AAJhB;AAQY;EACI,mBAAA;AANhB;AAQY;EACI,kCAAA;AANhB;AAQY;EAII,mBAAA;AAThB;AAMgB;EACI,oEAAA;AAJpB;AASQ;EACI,+BAAA;AAPZ;AAUQ;EACI,gCAAA;AARZ;AAWQ;EACI,gCAAA;EACA,+BAAA;AATZ;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AAVZ;AAYQ;EACI,eAAA;EACA,4BAAA;AAVZ;AAWY;EAAU,aAAA;AARtB;AAUQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AARZ;AAWQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AATZ;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAVZ;AAYQ;EACI,sBAAA;AAVZ;AAYQ;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AAVZ;AAYY;EACI,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAVhB;AAaY;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAXhB;AAYgB;EACI,yBAAA;AAVpB;AAagB;EACI,yBAAA;AAXpB;AAeoB;EACI,yBAAA;AAbxB;AAiBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAfpB;AAkBgB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAhBpB;AAkBoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAhBxB;AAkBwB;EACI,gBAAA;AAhB5B;AAoBoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAlBxB;AAwBQ;EACI,aAAA;EACA,eAAA;AAtBZ;AAwBgB;EACI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;AAtBpB;AAuBoB;EACI,yBAAA;AArBxB;AA0BQ;EACI,wBAAA;EACA,gBAAA;AAxBZ;AA0BY;EACI,eAAA;EACA,4BAAA;EACA,YAAA;AAxBhB;AA0BgB;EACI,aAAA;AAxBpB;AA8BI;EACI;IACI,UAAA;EA5BV;EA+BM;IACI,UAAA;EA7BV;AACF;;ACzMY;ED4OJ;IAA+B,aAAA;EA9BrC;EA+BM;IACI,aAAA;EA7BV;EA+Bc;IACI,iBAAA;EA7BlB;EA8BkB;IACI,UAAA;EA5BtB;EA+Bc;IACI,aAAA;EA7BlB;EA8BkB;IACI,uBAAA;IACA,YAAA;EA5BtB;AACF;ACtOY;EDmPJ;IAA+B,aAAA;EATrC;EAUM;IACI,aAAA;EARV;EAUc;IACI,iBAAA;EARlB;EASkB;IACI,UAAA;EAPtB;EAUc;IACI,aAAA;EARlB;EASkB;IACI,uBAAA;IACA,YAAA;EAPtB;AACF;AC3PY;ED4QA;IACI,sBAAA;IACA,mBAAA;EAdd;EAgBU;IACI,YAAA;EAdd;EAgBU;IACI,WAAA;IACA,6BAAA;EAdd;EAec;IACI,0BAAA;EAblB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.agent-dashboard-container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    font-family: \"Proxima Nova\", sans-serif;\n    .table-filters {\n        display: flex;\n        column-gap: 24px;\n        > div {\n            align-items: center;\n            display: flex;\n            column-gap: 8px;\n        }\n        .suggestion {\n            position: absolute;\n            top: 100%;\n            left: 0;\n            width: 300px;\n            max-height: 200px;\n            overflow-y: auto;\n            border-radius: 4px;\n            box-shadow: 0px 5px 20px 0px #EBEBEB;\n            z-index: 1000;\n            background-color: white;\n            border-radius: 10px;\n            .suggestion-item {\n                padding: 0px 10px;\n                cursor: pointer;\n                border-bottom: 1px solid #eee;\n                font-size: 14px;\n                transition: .2s ease-in-out;\n                &:hover {\n                    background-color: #f1f1f1;\n                }\n            }\n            \n        }\n    }\n    .contents {\n        margin-top: 60px;\n        max-height: calc(100vh - 140px);\n        p {\n            margin: 0;\n        }\n        .showings-today-container {\n            height: calc(100vh - 292px);\n        }\n        .block {\n            padding: 24px;\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n\n            .data {\n                >div {\n                    flex: 1;\n                }\n            }\n        }\n\n        .view-all {\n            font-size: 12px;\n            font-weight: 700;\n            color: #5F5F5F;\n            cursor: pointer;\n            transition: .2s ease-in-out;\n\n            &:hover {\n                opacity: .75;\n            }\n        }\n        .divider {\n            &.team-member {\n                background: #88B7FF;\n            }\n            &.listing-agent {\n                background: var(--primary-color-1);\n            }\n            &.buyer-agent {\n                &.listing-agent {\n                    background: linear-gradient( #9E3645 50%, var(--primary-color-1) 50%);\n                }\n                background: #9E3645;\n            }\n        }\n        .border-r {\n            border-right: 1px solid #E4E4E4;\n        }\n\n        .border-b {\n            border-bottom: 1px solid #E4E4E4;\n        }\n\n        .border-rb {\n            border-bottom: 1px solid #E4E4E4;\n            border-right: 1px solid #E4E4E4;\n        }\n\n        .header {\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 16px;\n            color: var(--secondary-color-1);\n        }\n        .link {\n            cursor: pointer;\n            transition: .2s ease-in-out;\n            &:hover { opacity: .75; }\n        }\n        .subheader {\n            font-size: 12px;\n            color: #5F5F5F;\n            font-weight: 600;\n        }\n\n        .title {\n            color: #949494;\n            font-weight: 500;\n            font-size: 12px;\n        }\n\n        .data {\n            font-weight: 400;\n            font-size: 24px;\n            color: var(--secondary-color-1);\n        }\n        .list {\n            animation: fadein .5s;\n        }\n        .showings-today {\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            animation: fadein .5s;\n\n            img {\n                max-height: 170px;\n                width: 100%;\n                object-fit: cover;\n                border-radius: 24px;\n            }\n\n            .user {\n                display: flex;\n                margin-top: 15px;\n                height: 56px;\n                background-color: var(--secondary-color-4);\n                padding: 12px 16px;\n                border-radius: 14px;\n                width: 100%;\n                &.la {\n                    background-color: #FEF7DE;\n                }\n\n                &.ba {\n                    background-color: #FEF2F2;\n                }\n\n                &.buyer {\n                    &.Q {\n                        background-color: #fef0de;\n                    }\n                }\n\n                .profile {\n                    width: 32px;\n                    height: 32px;\n                    align-self: center;\n                    border-radius: 100%;\n                }\n\n                .detail {\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n\n                    span:first-child {\n                        font-size: 12px;\n                        color: #2a2a2a;\n                        font-weight: 700;\n                        margin-bottom: 5px;\n\n                        >svg {\n                            margin-left: 3px;\n                        }\n                    }\n\n                    span:last-child {\n                        font-size: 10px;\n                        color: #949494;\n                        font-weight: 700;\n                    }\n                }\n            }\n\n        }\n        .splide__pagination {\n            display: flex;\n            column-gap: 5px;\n            li {\n                button.splide__pagination__page {\n                    height: 4px !important;\n                    width: 4px !important;\n                    padding: 0;\n                    border: none;\n                    border-radius: 100%;\n                    background-color: #C9C9C9;\n                    transition: .2s ease-in-out;\n                    &.is-active {\n                        background-color: #949494;\n                    }\n                }\n            }\n        }\n        .splide__arrows {\n            display: flex !important;\n            column-gap: 16px;\n\n            .splide__arrow {\n                cursor: pointer;\n                transition: .2s ease-in-out;\n                height: 16px;\n\n                &:hover {\n                    opacity: .75;\n                }\n            }\n        }\n    }\n\n    @keyframes fadein {\n        from {\n            opacity: 0;\n        }\n\n        to {\n            opacity: 1;\n        }\n    }\n}\n\n@include media(tablet, mobile) {\n    .agent-dashboard-container {\n        .dashboard-filters-container { display: none; }\n        .contents {\n            margin-top: 0;\n            .block  {\n                .data {\n                    flex-wrap: nowrap;\n                    >  div {\n                        flex: none;\n                    }\n                }\n                .list {\n                    row-gap: 30px;\n                    > li {\n                        flex-wrap: wrap-reverse;\n                        row-gap: 8px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .agent-dashboard-container {\n        .contents {\n            > div {\n                flex-direction: column;\n                align-items: center;\n            }\n            .showings-today-container {\n                height: 100%;\n            }\n            .block  {\n                width: 100%;\n                border-right: none !important;\n                &.no-max-mobile {\n                    max-width: none !important;\n                }\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
